import { useEffect, useState } from "react";
import { api } from "../auth/AuthContext";

/**
 * The landing page behind a drip email's one-click unsubscribe link (KEY-433) — a sessionless front
 * door like the campaign join page, because the click comes from an inbox, not a session.
 *
 * The revoke fires on arrival, no confirmation step: someone who clicked "stop these emails" has
 * already decided, and a page that asks again is a dark pattern with a doorbell. The token is opaque
 * and single-purpose, so loading this URL can do nothing except what the link promised.
 */
export function Unsubscribe() {
  const token = window.location.pathname.split("/")[2] ?? "";
  const [state, setState] = useState<"working" | "done" | "invalid">("working");

  useEffect(() => {
    let cancelled = false;
    api
      .unsubscribeMarketing(token)
      .then((ok) => !cancelled && setState(ok ? "done" : "invalid"))
      .catch(() => !cancelled && setState("invalid"));
    return () => {
      cancelled = true;
    };
  }, [token]);

  return (
    <main className="buy-page">
      <header className="buy-header">
        {state === "working" && <p className="buy-muted">One moment…</p>}
        {state === "done" && (
          <>
            <h1>You're unsubscribed</h1>
            <p className="buy-muted">
              No more emails like that one. Anything about your account itself — a trial ending, a
              receipt — still reaches you, because you'd want to know.
            </p>
          </>
        )}
        {state === "invalid" && (
          <>
            <h1>That link didn't work</h1>
            <p className="buy-muted">
              It may have been cut short by your email app. Reply to the email instead and a person
              will take you off the list.
            </p>
          </>
        )}
      </header>
    </main>
  );
}
